import {uiMsg} from '../utils/Languages';
import {observable, autorun, computed} from 'mobx';
import * as LoadLevel from './LoadLevel';

// For now this is just a blind copy of the rows from the database.
function createSimCardFromDBRow(row) {
  var s = new SimCard();  
  s.iccid=row.iccid;
  s.name=row.name;
  s.status=row.status;
  s.data=row.data;
  s.sms=row.sms;
  s.customerId=row.id_customer;
  s.machineId=row.id;
  s.dataId=row.dataId;
  s.smsId=row.smsId;
  s.roaming=row.roaming;
  s.phone=row.phoneNumber;
  return s;
}

class SimCard {
  @observable iccid;
  @observable name;
  @observable status;
  @observable data;
  @observable dataId;
  @observable sms;
  @observable smsId;
  @observable customerId;
  @observable machineId;
  @observable roaming;
  @observable phone;
  @observable updatingSimCard = false;
 

  constructor(sim=null) {
    this.reset();
    if(sim != null){
      this.iccid = sim.iccid;
      this.name = sim.name;
      this.status = sim.status;
      this.data = sim.data;
      this.sms = sim.sms;
      this.customerId = sim.customerId;
      this.machineId = sim.machineId;
      this.dataId = sim.dataId;
      this.smsId = sim.smsId;
      this.updatingSimCard = sim.updatingSimCard;
      this.roaming = sim.roaming;
      this.phone = sim.phone;
    }
  }
  reset() {
    this.iccid=null;
    this.name=null;
    this.status=null;
    this.data=null;
    this.sms=null;
    this.customerId=null;
    this.machineId=null;
    this.dataId=null;
    this.smsId=null;
    this.updatingSimCard=false;
    this.roaming=null;
    this.phone=null;
  }
  @computed get freezed() {
    return this.status == 'paused';
  }

  @computed get _name() {
    return !!this.name ? this.name : '';
  }
  @computed get _status() {
    return !!this.status ? this.status : '';
  }
  @computed get _machineId() {
    return !!this.machineId ? this.machineId : '';
  }
  @computed get _data() {
    return !!this.data ? this.data : '';
  }
  @computed get _sms() {
    return !!this.sms ? this.sms : '';
  }

  @computed get readable() {
    return  this.iccid+" "+this.name+" "+this.status+" ";
  }
  
}

// Make utility method available from Class (function)
SimCard.createFromDBRow=createSimCardFromDBRow;

export default SimCard;



/** WEBPACK FOOTER **
 ** ./src/DataModel/SimCard.js
 **/